import { useEffect, useState } from "react";
import { getData, insertData, updateData, deleteData } from "../api";
import { Box, Typography, Button, TextField, List, ListItem, ListItemText, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import TeamPlayerManager from "../components/TeamPlayerManager";
import theme from "../styles/theme";

interface Team {
  id: number;
  name: string;
}

export default function ManageTeams() {
  const [teams, setTeams] = useState<Team[]>([]);
  const [newTeamName, setNewTeamName] = useState("");
  const [editTeam, setEditTeam] = useState<Team | null>(null);
  const [editName, setEditName] = useState("");
  const [deleteId, setDeleteId] = useState<number | null>(null);

  useEffect(() => {
    getData("teams").then((res: any) => setTeams(res.data || []));
  }, []);

  const handleAdd = async () => {
    if (!newTeamName.trim()) return;
    await insertData("teams", { name: newTeamName });
    getData("teams").then((res: any) => setTeams(res.data || []));
    setNewTeamName("");
  };

  const handleEdit = (team: Team) => {
    setEditTeam(team);
    setEditName(team.name);
  };

  const handleEditSave = async () => {
    if (!editTeam || !editName.trim()) return;
    await updateData("teams", { name: editName }, `id = ${editTeam.id}`);
    getData("teams").then((res: any) => setTeams(res.data || []));
    setEditTeam(null);
    setEditName("");
  };

  const handleDelete = async () => {
    if (deleteId == null) return;
    await deleteData("teams", `id = ${deleteId}`);
    getData("teams").then((res: any) => setTeams(res.data || []));
    setDeleteId(null);
  };

  return (
    <Box sx={{ padding: 2, maxWidth: 1200, margin: "0 auto" }}>
      <Typography variant="h2" sx={{ mb: 3, color: theme.palette.primary.main }}>
        Gestion des équipes
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        <TextField
          label="Nom de l'équipe à ajouter"
          value={newTeamName}
          onChange={e => setNewTeamName(e.target.value)}
          sx={{ flex: 1 }}
        />
        <Button variant="contained" onClick={handleAdd}>
          Ajouter
        </Button>
      </Box>
      <List style={{ background: theme.palette.background.paper, maxHeight: 300, overflowY: 'auto', marginBottom: 20 }}>
        {teams.map(team => (
          <ListItem key={team.id} secondaryAction={
            <>
              <IconButton onClick={() => handleEdit(team)}><Edit /></IconButton>
              <IconButton onClick={() => setDeleteId(team.id)} color="error"><Delete /></IconButton>
            </>
          }>
            <ListItemText primary={team.name} />
          </ListItem>
        ))}
      </List>
      {/* Gestion des équipes et joueurs (drag & drop) */}
      <TeamPlayerManager teams={teams} />
      {/* Dialog édition */}
      <Dialog open={!!editTeam} onClose={() => setEditTeam(null)}>
        <DialogTitle>Modifier l'équipe</DialogTitle>
        <DialogContent>
          <TextField
            label="Nom de l'équipe"
            value={editName}
            onChange={e => setEditName(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditTeam(null)}>Annuler</Button>
          <Button onClick={handleEditSave} variant="contained">Enregistrer</Button>
        </DialogActions>
      </Dialog>
      {/* Dialog suppression */}
      <Dialog open={deleteId != null} onClose={() => setDeleteId(null)}>
        <DialogTitle>Supprimer l'équipe</DialogTitle>
        <DialogContent>
          Voulez-vous vraiment supprimer cette équipe ?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteId(null)}>Annuler</Button>
          <Button onClick={handleDelete} color="error" variant="contained">Supprimer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
